export const pkg = {
  name: 'isomorphic-git',
  version: '1.24.5',
  agent: 'git/isomorphic-git@1.24.5',
}
